"use client"

import {
    Carousel,
    CarouselContent,
    CarouselItem,
} from "./ui/carousel"
import {P} from "./ui/P"
import Dots from "@/components/ui/dots";
import {useState} from "react";
import {Button} from "@/components/ui/button";

const items = [
    {
        title: "🏠 Срочная продажа — 2-комнатная квартира, Мурманск",
        client: "Александр",
        description: "Клиент перезжает в другой город, не мог продать квартиру уже 3 месяца. Квартира была в ипотеке банка.Мы выкупили квартиру за 3 дня!",
        steps: [
            "Обращение клиента, оценка и проверка квартиры",
            "Сбор документов и подготовка договора",
            "Закрытие сделки с полным рассчетом",
        ],
    },
    {
        title: "🛏 Продажа комнаты в коммуналке, ул. Папанина",
        client: "Татьяна",
        description: "У клиента возникли сложности с соседями (отказами от покупки) при продаже. Выкупили комнату за 2 дня! ",
        steps: [
            "Консультация, сложности с соседями",
            "Согласие и проверка юриста",
            "Сделка и выплата на месте",
        ],
    },
    {
        title: "📐 Выкуп доли в квартире, пр. Ленина",
        client: "Евгений",
        description: "При продаже доли клиент не мог договорится с совладельцами, в квавртиру его не пускали, комунальные платежи не оплачивали. Провели переговоры, нашли компромисы, выкупили долю за 5 дней. ",
        steps: [
            "Запрос на выкуп 1/3 доли, оценка",
            "Согласование с совладельцами",
            "Договор, перевод средств",
        ],
    },
    {
        title: "📦 Срочная продажа 1-комнатной, ул. Беринга",
        client: "Наталья",
        description: "Клиент из другого региона, получил квартиру в наследство. Возможности приехать в Мурманск небыло. Провели удаленную сделку, выкупили квартиру за 2 дня. ",
        steps: [
            "Обращение и оценка за 2 часа",
            "Оформление договора",
            "Расчёт в день сделки.",
        ],
    },
    {
        title: "🔐 Продажа доли с обременением, ул. Полярные Зори",
        client: "Марина",
        description: "Объект недвижимости с долгами по ЖКХ. Сделка прошла в 2 этапа: снятие обременений с доли, выход на основной договор! Выкупили долю за 4 дня.",
        steps: [
            "Провели Оценку и Юридическую проверку",
            "Сняли обременения",
            "Окончательный рассчет на сделке",
        ],
    },
]

export default function HistoryCarousel() {
    const [currentSlide, setCurrentSlide] = useState(0);

    return (
        <section className="bg-gray-50 ">
            <div className={'max-w-custom relative  mx-auto px-4 py-8'}>
                <P size="l" className="text-gray-400 w-60 font-semibold mb-6 ml-5 lg:ml-8">
                    Истории наших клиентов:
                </P>
                <div className={'grid grid-cols-1 lg:grid-cols-2 gap-6 items-top'}>
                    <div className={'relative hidden lg:block'}>
                        <img className={' opacity-30 py-3'} src={'/fon2.jpg'}/>
                        <div className="absolute top-16 left-7 max-w-sm ">
                            <P size={'l'} className="text-orange-600 font-bold">Более 10 лет</P>
                            <span className="text-sm text-gray-700 leading-relaxed block mt-1">
        Центр недвижимости <strong>Мурман Клик</strong> помогает людям решать сложные задачи по продаже и выкупу недвижимости. Срочно, безопасно и с полным сопровождением.
    </span>
                            <Button className={'mt-8 text-sm'}>ПОДРОБНЕЕ</Button>
                        </div>

                    </div>
                    <Carousel className="w-full group">
                        <CarouselContent>
                            {items.map((item, index) => (
                                <CarouselItem
                                    key={index}
                                    className="md:basis-full px-3 pb-3">
                                    <div
                                        className="relative flex flex-col gap-4 rounded-2xl bg-white p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100">
                                        {/* Заголовок */}
                                        <div className="flex items-center gap-2 text-orange-600 font-semibold text-sm">
                                            <span className="text-xl">{item.title.split(' ')[0]}</span>
                                            <span>{item.title.replace(/^[^\s]+\s/, '')}</span>
                                        </div>

                                        {/* Проблема */}
                                        <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                                            <p className="text-sm text-gray-600 font-semibold mb-1">🧩 Проблема:</p>
                                            <p className="text-sm text-gray-700">{item.description}</p>
                                        </div>

                                        {/* Решение */}
                                        <div className="flex flex-col gap-2">
                                            <p className="text-sm text-gray-600 font-semibold">🛠 Что мы сделали:</p>
                                            {item.steps.map((step, idx) => (
                                                <div key={idx} className="flex items-start gap-2">
                                                    <span className="mt-[6px] w-2 h-2 bg-orange-400 rounded-full"/>
                                                    <p className="text-sm text-gray-700 leading-snug">{step}</p>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Результат и клиент */}
                                        <div className="flex justify-between items-center mt-4">
                                            <div className="text-xs text-gray-500 italic">
                                                👤 {item.client}
                                            </div>
                                            <div className="text-xs font-medium text-blue-600">
                                                ✅ Сделка №{index + 1}
                                            </div>
                                        </div>
                                    </div>
                                </CarouselItem>
                            ))}

                        </CarouselContent>
                        <Dots
                            count={items.length}
                            current={currentSlide}
                            className=""
                        />
                    </Carousel>

                </div>
            </div>

        </section>
    );
}